/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_1 = 'http://10.50.16.213:40001/mock/295' as any;
const devUrl_0_0_0_1 = '' as any;
const prodUrl_0_0_0_1 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_1 = 'retdata' as any;

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `POST /api/form`
 */
export interface ApiFormPostRequest {
  /**
   * 表单模板id
   */
  formTemplateId?: number;
  /**
   * 名称
   */
  name: string;
  /**
   * 说明
   */
  description?: string;
  /**
   * 字段列表
   */
  paramValues?: {
    /**
     * 名称
     */
    param?: string;
    /**
     * 类型
     */
    paramType?: 1 | 2 | 3;
    /**
     * 文本值
     */
    paramText?: string;
    /**
     * 引用的规则id
     */
    paramRuleId?: number;
    /**
     * 函数类型
     */
    paramFunction?: 1 | 2;
  }[];
}

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `POST /api/form`
 */
export type ApiFormPostResponse = number;

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `POST /api/form`
 */
type ApiFormPostRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/295',
    '',
    'http://127.0.0.1',
    '/api/form',
    'retdata',
    string,
    string,
    false
  >
>;

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `POST /api/form`
 */
const apiFormPostRequestConfig: ApiFormPostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: '/api/form',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiFormPost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock表单管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2063)
 * @请求头 `POST /api/form`
 */
export const apiFormPost = /*#__PURE__*/ (requestData: ApiFormPostRequest, ...args: UserRequestRestArgs) => {
  return request<ApiFormPostResponse>(prepare(apiFormPostRequestConfig, requestData), ...args);
};

apiFormPost.requestConfig = apiFormPostRequestConfig;

/* prettier-ignore-end */
